import "vanilla-match-height";

window.addEventListener("load", () => {
  document.body.matchHeight({
    byRow: false,
    attributeName: "data-mh-blog",
  });
});
